export default __webpack_public_path__ + "static/media/icon.e8193997.svg";